/** appErrors - 화면 파일 불러오기 실패와 화면 코드에서 처리하지 못한 오류를 안내한다(라우터 onError, 앱 errorHandler). */
import { useToast } from '@/composables/useToast';
import { MSG } from '@/constants/messages';

// 배포 직후 옛 화면 파일 이름으로 받으려다 실패한 경우. 브라우저마다 문구가 다르다
const CHUNK_RE = /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS|Loading (CSS )?chunk .* failed/i;

export function isChunkLoadError(err) {
  return Boolean(err) && (err.name === 'ChunkLoadError' || CHUNK_RE.test(String(err.message ?? err)));
}

// 새로 불러오기와 시각. 테스트가 바꿔 끼울 수 있게 객체로 둔다
export const pageNav = { reload: (url) => window.location.assign(url), now: () => Date.now() };

const RELOAD_KEY = 'insait.screenReload';
const RELOAD_WINDOW = 10000;

/**
 * 화면 이동 중 오류. 화면 파일을 못 받은 경우면 그 주소로 새로 불러와 새 파일을 받는다(true).
 * 같은 주소를 10초 안에 또 새로 불러오지 않고 안내만 한다 - 파일이 정말 없으면 새로 불러오기를 되풀이하게 된다.
 */
export function handleRouteError(err, to) {
  if (!isChunkLoadError(err)) return false;
  const target = to?.fullPath || window.location.pathname;
  let last = null;
  try { last = JSON.parse(sessionStorage.getItem(RELOAD_KEY) || 'null'); } catch { last = null; }
  if (last?.target === target && pageNav.now() - last.at < RELOAD_WINDOW) {
    useToast().error(MSG.SCREEN_LOAD_FAILED);
    return true;
  }
  try { sessionStorage.setItem(RELOAD_KEY, JSON.stringify({ target, at: pageNav.now() })); } catch { /* 기록하지 못해도 한 번은 새로 불러온다 */ }
  pageNav.reload(target);
  return true;
}

let lastNotice = 0;

/** 화면 코드에서 처리하지 못한 오류. 같은 오류가 그릴 때마다 되풀이돼도 안내는 3초에 한 번 */
export function handleAppError(err, info) {
  console.error('[app] 처리하지 못한 화면 오류', info, err);
  if (handleRouteError(err, null)) return;
  const now = pageNav.now();
  if (now - lastNotice < 3000) return;
  lastNotice = now;
  useToast().error(MSG.SCREEN_ERROR);
}

export function installErrorHandling(app, router) {
  router.onError((err, to) => {
    if (!handleRouteError(err, to)) console.error('[router] 화면 이동 오류', err);
  });
  app.config.errorHandler = (err, _instance, info) => handleAppError(err, info);
}
